import { setCustomer } from './customer';
import { setFeedback, delayedClearFeedback } from './feedback';
import { navigate } from './high_level_actions';
import { handleCustomerResponse } from './helper_actions';
import { openLoginModal } from './active_modal';
import request from 'superagent';

export function changePassword(sNewPassword) {
  return (dispatch, getState) => {
    request
      .put('/svc/customer/changePassword')
      .send({
        id: getState().urlParams[0],
        token: getState().urlParams[1],
        password: sNewPassword
      })
      .set('Accept', 'application/json')
      .end((err, res) => {
        // TODO: real user messaging
        if (err || res.statusCode !== 200 ) {
          console.warn(err);
          return dispatch([
            setFeedback('Something went wrong! We could not change your password.'),
            delayedClearFeedback()
          ]);
        }

        let oFakeEvent = {
          preventDefault: () => {},
          currentTarget: { pathname: '/' }
        }

        return dispatch([
          setFeedback('Your password has been changed! Please log in with your new password.'),
          delayedClearFeedback(),
          openLoginModal(),
        ]);
      });
  }
}

export function updateCustomerCore(oUpdate) {
  return (dispatch, getState) => {
    // Optimistically update state right away
    let oCustomer = getState().customer;
    Object.keys(oCustomer).forEach((key) => {
      if (oUpdate.hasOwnProperty(key)) {
        oCustomer[key] = oUpdate[key]
      }
    });
    // customer obj from server doesn't include password; pass it in if user is changing it
    if (oUpdate.hasOwnProperty('password')){
      oCustomer.password = oUpdate.password;
    }
    oUpdate.customer_id = getState().customer.id;
    dispatch( setCustomer(oCustomer) );
    request
      .put('/svc/customer')
      .send(oUpdate)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        let sFeedback = err || res.statusCode !== 200 ? 'Sorry, an error occurred' : 'Your information has been updated';
        return dispatch( handleCustomerResponse( res, sFeedback ) );
      });
  }
}

export function updateCustomerAddress(oUpdate) {
  return (dispatch, getState) => {
    // Optimistically update state right away
    let oCustomer = getState().customer;
    Object.keys(oCustomer.shipping_address).forEach((key) => {
      if (oUpdate.shipping_address.hasOwnProperty(key)) {
        oCustomer.shipping_address[key] = oUpdate.shipping_address[key];
      }
    });
    dispatch( setCustomer(oCustomer) );
    request
      .put('/svc/customer/updateAddress')
      .send(oUpdate.shipping_address)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        let sFeedback = err || res.statusCode !== 200 ? 'Sorry, an error occurred' : 'Your address has been updated';
        return dispatch( handleCustomerResponse( res, sFeedback ) );
      });
  }
}

export function updateCustomerPrefs(oUpdate) {
  return (dispatch, getState) => {
    let oCustomer = getState().customer;
    oCustomer.email_preferences = oUpdate;
    dispatch( setCustomer(oCustomer) );

    request
      .put('/svc/customer/updatePrefs')
      .send(oUpdate)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        let sFeedback = err || res.statusCode !== 200 ? 'Sorry, an error occurred' : 'Your preferences have been updated';
        return dispatch( handleCustomerResponse( res, sFeedback ) );
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/update_customer_actions.js